import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { Title } from '@angular/platform-browser';
import { LoadingService } from '@services/loading/loading.service';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss']
})
export class AppComponent implements OnInit, OnDestroy {

  public currentRoute: string;
  public showLoading: boolean;
  private routerSubscription: Subscription;
  private loadingSubscription: Subscription;

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private titleService: Title,
    private loading: LoadingService,
  ) {
    this.showLoading = false;
    this.currentRoute = '';
  }

  public ngOnInit() {
    this.setLoadingSubscription();
    this.setRouterPipe();
  }

  public setRouterPipe() {
    this.routerSubscription = this.router.events.pipe(
      filter((event) => event instanceof NavigationEnd),
    ).subscribe((event: NavigationEnd) => {
      this.currentRoute = event.urlAfterRedirects;
      const childRoute = this.getChild(this.activatedRoute);
      childRoute.data.subscribe((data) => {
        this.titleService.setTitle(data.title);
      });
    });
  }

  public getChild(activatedRoute: ActivatedRoute): ActivatedRoute {
    return activatedRoute.firstChild ? this.getChild(activatedRoute.firstChild) : activatedRoute;
  }

  public ngOnDestroy() {
    this.routerSubscription.unsubscribe();
    this.loadingSubscription.unsubscribe();
  }

  private setLoadingSubscription() {
    this.loadingSubscription = this.loading.loadingRequestSource.subscribe((showLoading) => this.showLoading = showLoading);
  }
}
